import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '../../../base/ui/components/web/Dialog';
import { makeStyles } from 'tss-react/mui';
import { useSelector } from 'react-redux';
import { getLocalParticipant, getRemoteParticipants } from '../../../base/participants';
import { cloneDeep, uniqBy } from 'lodash';
import Avatar from '../../../base/avatar/components/Avatar';
import moment from 'moment';
import { TYPE } from './constant';
import { Avatar as AvatarMui } from '@mui/material';
import { IconArrowDown, IconArrowUp } from '../../../base/icons/svg';
import Icon from '../../../base/icons/components/Icon';
import { getPoll } from '../../functions';
const useStyles = makeStyles()(theme => {
    return {
        pollList: {
            display: 'flex',
            flexDirection: 'column'
        },
        pollItem: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: '16px 0 0 0',
            fontSize: '14px',
            paddingBottom: '6px'
        },
        pollName: {
            fontSize: '14px',
            overflowWrap: 'anywhere'
        },
        question: {
            fontSize: '16px',
            fontWeight: '600',
            margin: '16px 0 0 0',
            overflowWrap: 'anywhere'
        },
        userInfoPoll: {
            display: "flex",
            alignItems: 'center',
            width: '100%'
        },
        usernamePoll: {
            marginLeft: '8px'
        },
        contentItemPoll: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '12px',
            marginTop: '14px',
            fontSize: '14px'
        },
        end: {
            fontSize: '15px',
            fontWeight: '500',
            marginTop: '20px'
        },
        resultVote: {
            fontSize: '15px',
            fontWeight: '550',
            marginTop: '20px'
        },
        polls: {
            marginTop: '8px'
        },
        barContainer: {
            backgroundColor: theme.palette.grey05,
            borderRadius: '4px',
            height: '6px',
            width: '100%',
            marginTop: '2px',
            display: 'block'
        },
        bar: {
            height: '6px',
            borderRadius: '4px',
            backgroundColor: theme.palette.redP03
        },
        show: {
            cursor: 'pointer',
            paddingLeft: '4px',
            '& svg': {
                fill: 'inherit !important'
            }
        }
    };
});
function convertName(name) {
    return name;
}
/**
 *
 * @param {Object} props - The props of the component.
 * @returns {React$Element}
 */
const DetailPollDialog = ({ answers, poll: pollProp }) => {
    const { t } = useTranslation();
    const { classes } = useStyles();
    const [isTrigger, setIsTrigger] = useState(false);
    const [pollData, setPollData] = useState(null);
    const [pollAnswersConvert, setPollAnswersConvert] = useState([]);
    const [avatarSet, setAvatarSet] = useState([]);
    const [showOptions, setShowOptions] = useState([]);
    const participantName = useSelector((state) => {
        const remotes = state['features/base/participants'].remote;
        let remotesName = [];
        for (const [key, value] of remotes.entries()) {
            remotesName.push(value.name);
        }
        return remotesName;
    });
    const localParticipant = getLocalParticipant(APP.store.getState());
    const poll = useSelector(getPoll(pollProp?.pollId));
    const renderImageUserVote = (voters) => {
        const arrayImageUser = [];
        if (voters?.length <= 0) {
            return;
        }
        for (let i = 0; i < voters.length; i++) {
            if (i > 2) {
                return arrayImageUser;
            }
            if (i < 2) {
                arrayImageUser.push(React.createElement("div", { style: { marginLeft: i > 0 ? '-9px' : '0' } },
                    React.createElement(Avatar, { displayName: voters[i].uname, size: 24, avatarUrl: voters[i].loadableAvatarUrl })));
            }
            else {
                arrayImageUser.push(React.createElement("div", { style: { marginLeft: '-9px' } },
                    React.createElement(AvatarMui, { sx: { width: 24, height: 24 } },
                        React.createElement("span", { style: { fontSize: '12px' } },
                            "+",
                            voters.length - 2))));
            }
        }
        return arrayImageUser;
    };
    useEffect(() => {
        const newSet = [];
        pollAnswersConvert?.map((p) => (p.voters?.length > 0 && (p.voters?.map((u) => (newSet.push({
            id: u.uid,
            name: u.uname,
            avatarUrl: u.loadableAvatarUrl
        }))))));
        setAvatarSet(uniqBy(newSet, 'id'));
    }, [pollAnswersConvert]);
    useEffect(() => {
        const participants = [...getRemoteParticipants(APP.store.getState()).values()];
        const remoteParticipants = APP.store.getState()["features/filmstrip"].remoteParticipants;
        if (participants.length > 0) {
            const dataRemoteParticipants = participants[0]?.conference?.participants;
            const dataConverted = remoteParticipants.map((p) => {
                const uid = dataRemoteParticipants.get(p)?._id;
                const uname = dataRemoteParticipants.get(p)?._displayName;
                const isParticipant = participants.find(part => part.id === p);
                const loadableAvatarUrl = isParticipant?.loadableAvatarUrl;
                return {
                    uid,
                    uname,
                    loadableAvatarUrl
                };
            });
            setPollAnswersConvert(poll.answers.map((answer) => {
                const p = cloneDeep(answer);
                if (p.voters.size > 0) {
                    let dataReturn = [];
                    for (const [key, value] of p.voters.entries()) {
                        const isParticipant = dataConverted.find((d) => d.uid === key);
                        if (isParticipant) {
                            dataReturn.push({
                                nameAns: p.name,
                                uid: key,
                                uname: value || isParticipant.uname,
                                loadableAvatarUrl: isParticipant.loadableAvatarUrl
                            });
                        }
                        else {
                            if (key === localParticipant?.id) {
                                dataReturn.push({
                                    nameAns: p.name,
                                    uid: key,
                                    uname: localParticipant?.name,
                                    loadableAvatarUrl: localParticipant?.name === value ? localParticipant?.loadableAvatarUrl : localParticipant?.loadableAvatarUrl
                                });
                            }
                            else {
                                dataReturn.push({
                                    nameAns: value || t("polls.undefined"),
                                    uid: key,
                                    uname: value || t("polls.undefined"),
                                    loadableAvatarUrl: ""
                                });
                            }
                        }
                    }
                    p.voters = dataReturn;
                }
                return p;
            }));
        }
        else {
            setPollAnswersConvert(poll.answers.map((answer) => {
                const p = cloneDeep(answer);
                if (p.voters.size > 0) {
                    let dataReturn = [];
                    // for (let key of p.voters.keys()) {
                    for (const [key, value] of p.voters.entries()) {
                        dataReturn.push({
                            nameAns: p.name,
                            uid: key,
                            uname: value,
                            loadableAvatarUrl: localParticipant?.name === value ? localParticipant?.loadableAvatarUrl : undefined
                        });
                    }
                    p.voters = dataReturn;
                }
                return p;
            }));
        }
        // poll.answers = pollAnswersConvert
        setIsTrigger(!isTrigger);
        setPollData(poll);
    }, [poll, JSON.stringify(participantName), localParticipant]);
    return (React.createElement(Dialog, { ok: { hidden: true }, cancel: { translationKey: t("polls.dialog.back") }, titleKey: t('polls.dialog.title'), size: 'large' },
        React.createElement("div", null,
            poll.status === TYPE.ENDED &&
                React.createElement("div", { className: classes.end }, t("polls.dialog.end", { time: moment(poll?.end_time).format("HH:mm, DD/MM/YYYY") })),
            React.createElement("div", { className: classes.resultVote }, t("polls.dialog.result")),
            React.createElement("div", { className: classes.polls },
                React.createElement("div", { className: classes.question }, poll.question),
                React.createElement("div", { className: classes.pollList }, pollAnswersConvert.map((p, index) => {
                    return (React.createElement("div", null,
                        React.createElement("div", { className: classes.pollItem },
                            React.createElement("div", { className: classes.pollName }, p.name),
                            React.createElement("div", { style: { display: "flex", alignItems: "center", marginLeft: '4px', cursor: (poll?.anonymousPoll === false && p.voters.length > 0) ? 'pointer' : 'default' }, onClick: () => {
                                    if (poll?.anonymousPoll && p.voters.length > 0) {
                                        return;
                                    }
                                    if (showOptions?.includes(index)) {
                                        setShowOptions(showOptions.filter((op) => op !== index));
                                    }
                                    else {
                                        setShowOptions((prev) => [...prev, index]);
                                    }
                                } },
                                React.createElement("div", { style: { display: "flex", alignItems: "center" } }, poll?.anonymousPoll === false && renderImageUserVote(p.voters)),
                                React.createElement("span", { style: { fontWeight: '600', margin: "0 4px" } }, p.voters.length || 0),
                                `(${p.voters.length ? (Math.round((p.voters.length / avatarSet.length) * 100)) : 0}%)`,
                                poll?.anonymousPoll === false && p.voters?.length > 0 &&
                                    React.createElement("div", { className: classes.show },
                                        React.createElement(Icon, { size: 18, src: showOptions?.includes(index) ? IconArrowUp : IconArrowDown })))),
                        React.createElement("span", { className: classes.barContainer },
                            React.createElement("div", { className: classes.bar, style: { width: `${p.voters.length ? (Math.round((p.voters.length / avatarSet.length) * 100)) : 0}%` } })),
                        poll?.anonymousPoll === false && p.voters?.length > 0 && showOptions?.includes(index) &&
                            React.createElement("div", { className: classes.contentItemPoll }, (p.voters.map((u, index) => (React.createElement("div", { key: index, className: classes.userInfoPoll },
                                React.createElement("div", null,
                                    React.createElement(Avatar, { displayName: u.uname, size: 24, avatarUrl: u.loadableAvatarUrl })),
                                React.createElement("span", { className: classes.usernamePoll, title: u.uname }, convertName(u.uname)))))))));
                }))))));
};
export default DetailPollDialog;
